<template>
  <v-app class="homesync-card-app">
    <v-overlay :value="loader">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-main class="auth-pages" v-if="company" >
      <!-- Header with Login and Share buttons -->
       <v-container class="py-4">
      <div class="homesync-header">
        <v-btn
          icon
          color="white"
          @click="$router.push('/login')"
          class="header-btn"
        >
          <v-icon class="material-icons-round">login</v-icon>
        </v-btn>
        <v-btn
          icon
          color="white"
          @click="shareLink"
          class="header-btn"
        >
          <v-icon class="material-icons-round">share</v-icon>
        </v-btn>
      </div>

      <!-- Main Profile Section -->
      <div class="homesync-profile-section">
        <div class="profile-container">
          <!-- Profile Image -->
          <div class="profile-image-wrapper">
            <img
              :src="base_url_img+company.avatar"
              class="profile-image"
              alt="Profile Photo"
            >
          </div>

          <!-- Name and Title -->
          <h1 class="profile-name">{{company.first_name}} {{company.last_name}}</h1>
          <p class="profile-title">{{company.roles[0].description}}</p>
          <p class="profile-location" v-if="company.business_address">
            {{ getLocationShort(company.business_address) }}
          </p>

          <!-- CTA Button -->
          <v-btn
            class="cta-button"
            color="#4A9B8E"
            dark
            x-large
            rounded
            block
            @click="$router.push('/view-inventory')"
          >
            Start Your Home Journey
          </v-btn>

          <!-- Contact Icons -->
          <div class="contact-icons">
            <a :href="`tel:${company.phone_m}`" class="contact-icon">
              <i class="material-icons-round contact-icon-symbol">phone</i>
            </a>
            <a :href="`mailto:${company.email}`" class="contact-icon">
              <i class="material-icons-round contact-icon-symbol">email</i>
            </a>
            <a @click="shareLink" class="contact-icon" style="cursor: pointer;">
              <i class="material-icons-round contact-icon-symbol">link</i>
            </a>
          </div>
        </div>
      </div>

      <!-- Bottom Navigation Buttons -->
      <div class="bottom-nav-buttons">
        <div class="nav-button" @click="addCard()">
          <i class="fa fa-id-card nav-icon"></i>
          <span class="nav-label">Card</span>
        </div>
        <div class="nav-button" @click="overlay = true">
          <i class="fa fa-qrcode nav-icon"></i>
          <span class="nav-label">Scan</span>
        </div>
        <div class="nav-button" @click="$router.push('/reviews')">
          <i class="material-icons-round nav-icon">reviews</i>
          <span class="nav-label">Reviews</span>
        </div>
        <div class="nav-button" @click="callNumber(company.phone_m)">
          <i class="fas fa-phone-alt nav-icon"></i>
          <span class="nav-label">Direct Call</span>
        </div>
        <div class="nav-button" v-if="event_value" @click="gotoLinks(event_value)">
          <i class="fas fa-calendar-check nav-icon"></i>
          <span class="nav-label">Events</span>
        </div>
      </div>

      <!-- Footer Section -->
      <div class="homesync-footer">
        <div class="footer-content">
          <div class="footer-left">
            <h2 class="footer-brand mt-5">HomeSyncX</h2>
            <p class="footer-powered">Powered by TwinTalk</p>
          </div>
          <div class="footer-right">
            <div class="verified-badge">
              <div class="shield-container">
                <i class="material-icons-round verified-icon">shield</i>
              </div>
              <div class="verified-text">
                <span class="verified-partner">Verified</span>
                <span class="verified-partner">Partner</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Dialogs -->
      <v-dialog v-model="overlay" width="500">
        <v-card>
          <v-card-text class="text-center pa-4">
            <h3 class="mb-3">HomeSyncX QR Code</h3>
            <img v-if="homesyncQrUrl" :src="homesyncQrUrl" style="width: 100%; max-width: 400px;">
            <img v-else-if="company" :src="base_url_img+'vcard/'+company.user_id+'-home-QR.png'" style="width: 100%; max-width: 400px;">
            <v-progress-circular v-if="qrGenerating" indeterminate color="primary" class="mt-4"></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="overlay_inventory" width="500">
        <div style="margin-top: -25px;">
          <QueryLookingFor
            class="mt-5"
            :color="color"
            :ref_id="company.user_id"
            @closeModalQuery="overlay_inventory = false"
            @vehicle-viewed="handleVehicleViewed"
          />
        </div>
      </v-dialog>
    </v-container>
    </v-main>


    <!-- Reps View-->
    <v-main class="auth-pages" v-else >
    
        <div class="footer" id="myHeader" :style="'background-color:#272727'">
          <div class="elementor-container elementor-column-gap-default" style="width: 100%;">
            <v-row style="margin:0px!important;">
    <v-col style="padding: 1px;">
        <div class="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-a828a20" data-id="a828a20" data-element_type="column">
    <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-88f37c7 elementor-view-default elementor-widget elementor-widget-icon" data-id="88f37c7" data-element_type="widget" data-widget_type="icon.default">
      <div class="elementor-widget-container">
        <div class="elementor-icon-wrapper">
    <a class="elementor-icon" href="tel:6026930899">
    <i aria-hidden="true" class="fa fa-id-card" :style=" 'color:white!important'"></i>			</a>
    </div>
      </div>
      </div>
      <div class="elementor-element elementor-element-f383dda elementor-widget elementor-widget-heading" data-id="f383dda" data-element_type="widget" data-widget_type="heading.default">
      <div class="elementor-widget-container">
    <h6 class="elementor-heading-title-card elementor-size-default" ><a href="tel:6026930899" :style=" 'color:white!important'">Card</a></h6>		</div>
      </div>
        </div>
    </div>
    </v-col>
    <v-col style="padding: 1px;">
      <div class="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-1eed04c" data-id="1eed04c" data-element_type="column" id="share-my-card" @click="overlay = true">
    <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-61dd731 elementor-view-default elementor-widget elementor-widget-icon" data-id="61dd731" data-element_type="widget" data-widget_type="icon.default">
      <div class="elementor-widget-container">
        <div class="elementor-icon-wrapper">
    <a class="elementor-icon" href="#">
    <i aria-hidden="true" class="fa fa-qrcode" :style=" 'color:white!important'"></i>			</a>
    </div>
      </div>
      </div>
      <div class="elementor-element elementor-element-08fcb6e elementor-widget elementor-widget-heading" data-id="08fcb6e" data-element_type="widget" data-widget_type="heading.default">
      <div class="elementor-widget-container">
    <h6 class="elementor-heading-title-card elementor-size-default"><a href="#" @click="overlay = true" :style="'color:white!important'">Scan</a></h6>		</div>
      </div>
        </div>
    </div>
    </v-col>
    <v-col style="padding: 1px;">
      <div class="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-d7c2c7a" data-id="d7c2c7a" data-element_type="column">
    <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-5f80995 elementor-view-default elementor-widget elementor-widget-icon" data-id="5f80995" data-element_type="widget" data-widget_type="icon.default">
      <div class="elementor-widget-container">
        <div class="elementor-icon-wrapper">
    <a class="elementor-icon" :href="`tel:${company.phone_m}`">
    <i aria-hidden="true" class="fas fa-phone-alt" :style="'color:white!important'"></i>			</a>
    </div>
      </div>
      </div>
      <div class="elementor-element elementor-element-2432e95 elementor-widget elementor-widget-heading" data-id="2432e95" data-element_type="widget" data-widget_type="heading.default">
      <div class="elementor-widget-container">
    <h6 class="elementor-heading-title-card elementor-size-default"><a :href="`tel:${company.phone_m}`" :style="vcard.header_color=='Light Text' ? 'color:black!important' : 'color:white!important'">Direct Call</a></h6>		</div>
      </div>
        </div>
    </div>
    </v-col>
    <v-col v-if="event_value">
      <div class="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-5b2a404" data-id="5b2a404" data-element_type="column">
    <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-57f7405 elementor-view-default elementor-widget elementor-widget-icon" data-id="57f7405" data-element_type="widget" data-widget_type="icon.default">
      <div class="elementor-widget-container">
        <div class="elementor-icon-wrapper">
    <a class="elementor-icon" :href="event_value" target="_blank">
    <i aria-hidden="true" class="fas fa-calendar-check"></i>			</a>
    </div>
      </div>
      </div>
      <div class="elementor-element elementor-element-eb196fc elementor-widget elementor-widget-heading" data-id="eb196fc" data-element_type="widget" data-widget_type="heading.default">
      <div class="elementor-widget-container">
    <h6 class="elementor-heading-title-card elementor-size-default"><a :href="event_value" target="_blank">Events</a></h6>		</div>
      </div>
        </div>
    </div>
    </v-col>
    </v-row>
            </div>
        </div>
        <section class="elementor-section elementor-top-section elementor-element elementor-element-a14cd74 elementor-section-height-min-height elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-items-middle" data-id="a14cd74" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;video&quot;,&quot;background_video_link&quot;:&quot;https:\/\/player.vimeo.com\/video\/68384616?h=b4d1b9c66e&quot;,&quot;background_play_on_mobile&quot;:&quot;yes&quot;,&quot;shape_divider_bottom&quot;:&quot;triangle&quot;,&quot;shape_divider_bottom_negative&quot;:&quot;yes&quot;,&quot;_ha_eqh_enable&quot;:false}" :style="company.background ? 'background-image: url('+background+'); background-size: cover;  background-position: center;-repeat: no-repeat;' : ''">
              <div class="elementor-background-video-container" data-vimeo-initialized="true" v-if="company.video_background && company.video_background != 'null'">
                        <div class="elementor-background-video-embed"></div>
                    </div>
        <div class="elementor-container elementor-column-gap-default">
        <div class="elementor-column-header elementor-col-100 elementor-top-column elementor-element elementor-element-1d6f932" data-id="1d6f932" data-element_type="column">
    <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-09cffa4 elementor-widget elementor-widget-image" data-id="09cffa4" data-element_type="widget" data-widget_type="image.default">
      <div class="elementor-widget-container">
                            <img src="@/assets/img/logo-avatar.jpg" class="attachment-full size-full wp-image-689" alt="" decoding="async" loading="lazy"  sizes="(max-width: 600px) 100vw, 600px" width="600" height="600" >															</div>
      </div>
        </div>
    </div>
            </div>
    </section>
    <v-row style="display: flex; justify-content: space-around;margin:0px!important;" >
              <v-col cols="12" style="display: flex; justify-content: space-around; margin-top: 100px; " >
                <h1 class="mb-1 text-h4 text-typo font-weight-bold"> AutoSync Representatives </h1>
                </v-col>
                <v-col cols="12" style="display: flex; justify-content: space-around" >
                  <p class="font-weight-bold text-body text-sm" style="color: black;margin-top: -15px;">Total Representatives: {{ reps_users.length }}</p>
                </v-col>
                <v-col
                      cols="12"
                      md="6"
                    >
                    
                        <v-text-field
                            color="#e91e63"
                            label="Search Representative"
                            ref="name"
                            v-model="search_rep"
                            class="font-size-input input-style"
                          >
                          </v-text-field>
                    </v-col>
              </v-row>
          <v-row style="justify-content: center;margin-bottom: 150px;margin: 0;">
            <v-col cols="12" md="12" style="">
              <ProfileCards :users="filteredUsers" />
            </v-col>
          <v-col cols="12" md="12" style="margin-bottom: 40px !important;">
            <h1 class="text-h6 mt-3 text-center">Powered by <strong>HomeSyncX</strong></h1>
          </v-col>
          </v-row>
          <v-row style="justify-content: center;margin-bottom:50px!important;"></v-row>

                <v-dialog
                    v-model="overlay"
                    width="500"
                  >
                  <img v-if="company"  class="" :src="base_url_img+'vcard/'+company.user_id+'-QR.png'" width="50">
                
                
                </v-dialog>
                

    </v-main>

    <!-- Digital Assistant Chat -->
    <!-- <DigitalAssistantChat
      v-if="currentDomain && company"
      :domain="currentDomain"
      :user-id="company.user_id"
      :user-name="company.first_name"
      :user-avatar="base_url_img + company.avatar"
      :auto-start="true"
      ref="digitalAssistant"
    /> -->

  </v-app>
</template>
<script>
var slides = document.querySelectorAll(".slide");
var currentSlide = 0;


import AppBarBlurAuth from "@/components/AppBarBlurAuth";
import VCard from 'vcard-creator'
import { FadeTransition } from "vue2-transitions";
import QueryLookingFor from "@/components/Forms/QueryLookingFor.vue";
import ProfileCards from "@/components/Forms/ProfileCards.vue";
// import DigitalAssistantChat from "@/components/DigitalAssistantChat.vue";
export default {

  name: "page-layout",
  components: {
    AppBarBlurAuth,
    FadeTransition,
    ProfileCards,
    QueryLookingFor,
    // DigitalAssistantChat
  },
  data() {
    return {
       checkbox: false,
       showpassword : false,
       email : '',
      password : '',
      sales_agent_count: 0,
      overlay_inventory : false,
      search_rep: '',
      ref_agent_count: 0,
      phone : '',
      loader : true,
      background: '',
      vimeo_account: '',
      vimeo_id : '',
      reps_flag : false,
      company_settings : '',
      reps_users : [],
      overlay : false,
      index: 0,
      showPassword : false,
      zoom_value : '',
      base64Image :'',
      avatar_mimeType: '',
      event_value :'',
      dialog: false,
      color : '',
      videos : [],
      pageFlag: 'init',
      backgroundLogo: localStorage.getItem('admin_bg'),
      currentDomain: null,
      isDark :true,
      buttonFlag   : false,
      loadingLogo : false,
      url : '',
      items: [
        ],
      company : '',
      vcard : '',
      loadingFlag : false,
      base_url_img : process.env.VUE_APP_WASBI_URL,
      pageTitle: '',
      homesyncQrUrl: null,
      qrGenerating: false
    };
  },
  beforeCreate: function () {
    
},
created: function () {
      const domain = this.getSubdomain();
      this.currentDomain = domain;
      this.getSettings()
      if(domain)
        this.getCompanyInfo(domain)
      else
        this.$router.push('/login');
        

},
mounted : function () {
  // Register digital assistant instance globally
  if (this.$refs.digitalAssistant) {
    this.$digitalAssistant.setInstance(this.$refs.digitalAssistant);
  }

  // Listen for global vehicle tracking events
  this.$root.$on('vehicle-viewed', this.handleGlobalVehicleView);
  this.$root.$on('vehicle-detail-viewed', this.handleGlobalVehicleDetailView);
  this.$root.$on('vehicle-search', this.handleGlobalVehicleSearch);
},

beforeDestroy() {
  // Clean up event listeners
  this.$root.$off('vehicle-viewed', this.handleGlobalVehicleView);
  this.$root.$off('vehicle-detail-viewed', this.handleGlobalVehicleDetailView);
  this.$root.$off('vehicle-search', this.handleGlobalVehicleSearch);
},
methods: {
  getLocationShort(address) {
    if (!address) return '';
    // Extract city and state from address (e.g., "Dallas, TX")
    const parts = address.split(',');
    if (parts.length >= 2) {
      const city = parts[parts.length - 2].trim();
      const state = parts[parts.length - 1].trim().split(' ')[0];
      return `${city}, ${state}`;
    }
    return address;
  },
  prevSlide(index) {
  if(index !=0 )
    this.index = index - 1;
  else
    this.index = this.videos.length - 1;

},
setMetaTag(metaTags) {
    let headTag = document.getElementsByTagName('head')[0]
      for (const i in metaTags) {
        // First, delete the meta tags.
        let oldTag = document.querySelector(`meta[name="${metaTags[i].name}"]`)
        if (oldTag) {
          document.querySelector(`meta[name="${metaTags[i].name}"]`).remove()
        }
        // Second, insert the replacement meta tags.
        let newTag = document.createElement('meta')
        newTag.setAttribute('name', metaTags[i].name)
        newTag.setAttribute(metaTags[i].name, metaTags[i].content)
        headTag.appendChild(newTag)
      }
    },

// Handle vehicle viewed events for digital assistant tracking
handleVehicleViewed(eventData) {
  console.log('Vehicle viewed in Card.vue:', eventData);

  // Pass to digital assistant for tracking
  if (this.$refs.digitalAssistant) {
    this.$refs.digitalAssistant.trackVehicleView(
      eventData.vehicle_id,
      eventData.vehicle_data
    );
  }
},

// Handle global vehicle view events
handleGlobalVehicleView(eventData) {
  console.log('Global vehicle view:', eventData);

  if (this.$refs.digitalAssistant) {
    this.$refs.digitalAssistant.trackVehicleView(
      eventData.vehicle_id,
      eventData.vehicle_data
    );
  }
},

// Handle global vehicle detail view events
handleGlobalVehicleDetailView(eventData) {
  console.log('Global vehicle detail view:', eventData);

  if (this.$refs.digitalAssistant) {
    this.$refs.digitalAssistant.trackVehicleView(
      eventData.vehicle_id,
      eventData.vehicle_data
    );
  }
},

// Handle global vehicle search events
handleGlobalVehicleSearch(eventData) {
  console.log('Global vehicle search:', eventData);

  // Could be used to inform the AI about user search preferences
  if (this.$refs.digitalAssistant) {
    // Store search context for AI
    this.$refs.digitalAssistant.searchContext = eventData.search_params;
  }
},

nextSlide(index) {
  if(index != this.videos.length - 1 )
    this.index = index + 1
  else
    this.index = 0
},
gotopayemnt: function () {
    let self = this;
    self.$router.push('/card-payment/'+this.$route.params.id);
},
checkSocial(social){
  if(!this.company.social_flags)
    return true;
  let social_flags = JSON.parse(this.company.social_flags);
  if(social_flags[social] == 1)
    return true;
  return false;
},
getSubdomain() {
    const hostname = window.location.hostname;
    const domainParts = hostname.split('.');

    // Assuming the domain is of the form subdomain.example.com
    // Exclude 'www' as a subdomain
    if (domainParts.length > 2 && domainParts[0] !== 'www') {
        return domainParts[0];
    } else {
        return null; // No subdomain
    }
}
,
 getCompanyInfo(id){

  axios({
          method: "POST",

          url: "/api/get-card",
          data: {
            id: id
          }

        })
          .then(async(response) => {
            if(response.data.flag == 1){
              if(id == 'reps'){

                this.reps_users = response.data.user;
                this.reps_flag = true;
                this.loader = false

              }else{
                this.company = response.data.user;
                this.vcard = response.data.vcard[0];
                this.sales_agent_count = response.data.sales_agents
                this.ref_agent_count = response.data.ref_agents
                // this.background =   this.base_url_img+'vcard/'+this.company.background
                // this.company.items = JSON.parse(JSON.parse(this.company.items))
                if(this.company.video_background){
                  let video_back = this.company.video_background.split("/");
                  this.vimeo_id = video_back[0]
                  this.vimeo_account = video_back[1]
                }
                this.loader = false
                let url = process.env.VUE_APP_WASBI_URL.replace('/logo','');
                const{base64Image, mimeType} = await this.convertImageToBase64(this.base_url_img+this.company.avatar);
                this.base64Image = base64Image
                this.avatar_mimeType = mimeType

                // Check and generate HomeSyncX QR code if needed
                await this.checkAndGenerateHomeSyncQR();
              }
            }else{
              this.$router.push('/login');
            }
          })

},
async checkAndGenerateHomeSyncQR() {
  if (!this.company || !this.company.user_id) return;

  // Check if HomeSyncX QR code exists
  const homesyncQrUrl = this.base_url_img + 'vcard/' + this.company.user_id + '-home-QR.png';

  try {
    // Try to load the image to check if it exists
    const response = await fetch(homesyncQrUrl, { method: 'HEAD' });

    if (response.ok) {
      // QR code exists, use it
      this.homesyncQrUrl = homesyncQrUrl;
    } else {
      // QR code doesn't exist, generate it
      await this.generateHomeSyncQR();
    }
  } catch (error) {
    // If fetch fails, try to generate QR
    await this.generateHomeSyncQR();
  }
},
async generateHomeSyncQR() {
  if (this.qrGenerating) return; // Prevent duplicate requests

  this.qrGenerating = true;

  try {
    const response = await axios.post('/api/generate-homesync-qr', {
      user_id: this.company.user_id
    });

    if (response.data.flag === 1) {
      this.homesyncQrUrl = response.data.qr_url;
      console.log('HomeSyncX QR code generated:', response.data);
    }
  } catch (error) {
    console.error('Error generating HomeSyncX QR code:', error);
  } finally {
    this.qrGenerating = false;
  }
},
async copyURL() {
  console.log(window.location);
      try {
        await navigator.clipboard.writeText(window.location);
        alert('URL Copied, Now you can share the URL');
      } catch($e) {
        alert('Cannot copy');
      }
    },
checkFormSignup(){
  let flag = 1;
      if (!this.email) {
        Vue.$toast.error('Email is required', {
            position: 'top-right'
        });
        this.$refs['email'].focus()
        flag = 0;
      }
      if (!this.password && flag == 1) {
        Vue.$toast.error('Password is required', {
            position: 'top-right'
        });
        this.$refs['password'].focus()
        flag = 0;
      }

      if (flag == 1) {
        localStorage.setItem('temp_email',this.email)
        localStorage.setItem('temp_pass',this.password)
        localStorage.setItem('email_verified',0)
        if(this.company)
          this.$router.push('/signup/'+this.url)
        else
          this.$router.push('/signup')
      }
},
getStyle(flag){
  let self = this;
  let color = this.vcard.color;
  let font = this.vcard.header_color;
  let color_code = '';
  const colorArray = [
  { name: 'Orange', code: '#FD7E14' },
  { name: 'Green', code: '#28A745' },
  { name: 'Purple', code: '#6F42C1' },
  { name: 'Red', code: '#DC3545' },
  { name: 'Pink', code: '#E83E8C' },
  { name: 'Blue', code: '#007BFF' },
  { name: 'Dark Blue', code: '#0033cc' },
  { name: 'Black', code: '#000000' },
  { name: 'Silver', code: '#C0C0C0' },
  { name: 'Hot Pink', code: '#FF69B4' },
  { name: 'Flat Black', code: '#2D3436' }
];
colorArray.forEach(element => {
  if(element.name == color){
    color_code = element.code;
    self.color = color_code;
  }
});
if(flag == 'footer'){
  return 'background-color:'+color_code;
}
if(flag == 'button'){
  return color_code;
}

},
forgotPass(){
    this.buttonFlag =true;
    this.isDark = false;
    axios({
          method: "POST",
           
          url: "/api/auth/forgot-password",
          data: {
            email: this.email,
          }
        })
          .then(response => {
                this.sendFlag = 1;
                Vue.$toast.success('Forgot Password Mail sent', {
                position: 'top-right'
                });
                this.buttonFlag =false;
                this.isDark = true;
                this.pageFlag = 'login';
          })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });
          })
},
gotosignup: function () {
    let self = this;
    self.$router.push('/signup');
},gotoGoogle(){
      let self = this;
        this.$router.push('/redirect/google');
        location.reload();
  },
  gotoMs(){
      let self = this;
        this.$router.push('/redirect/microsoft');
        location.reload();
  },
  gotoYahoo(){
      let self = this;
        this.$router.push('/redirect/yahoo');
        location.reload();
  },
  callNumber(phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    },
    sendEmail(email) {
      window.location.href = `mailto:${email}`;
    },
    gotoLinks(link){
      if(!link)
      link = '#'
      const newTab = window.open('', '_blank');
      newTab.location.href = link;
    },
    shareLink() {      
      const url = window.location.origin+'/form-ref/'+this.company.user_id
      if (navigator.share) {
          navigator
            .share({
              title: "Signup to HomeSync™",
              text: "Become a Referral Agent",
              url: url
            })
            .then(() => console.log("thanks for share"))
            .catch(error => console.log("error", error));
        }
    },
    addContact() {
      const contact = {
        name: "John Doe",
        phone: "123-456-7890",
        email: "johndoe@example.com",
        address: "1234 Example St, Anytown, USA",
      };

      if ('contacts' in navigator && 'ContactsManager' in window) {
        navigator.contacts.select(
          ['name', 'email', 'tel', 'address'],
          { multiple: false }
        ).then((contacts) => {
          const newContact = new Contact({
            name: [contact.name],
            tel: [{ value: contact.phone }],
            email: [{ value: contact.email }],
            address: [{ value: contact.address }],
          });
          newContact.save();
        }).catch((error) => {
          console.error('Error adding contact:', error);
        });
      } else {
        alert(`Name: ${contact.name}\nPhone: ${contact.phone}\nEmail: ${contact.email}\nAddress: ${contact.address}`);
      }
    },
    openInGoogleMaps(address) {      
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.company_settings.business_address)}`;
      window.open(googleMapsUrl, '_blank');
    },
    gotoVideo() {
      const googleMapsUrl = this.company_settings.video_meeting_link;
      window.open(googleMapsUrl, '_blank');
    },
    getSettings() {
    let flag = 1;
    let url = process.env.VUE_APP_WASBI_URL
    var config = {headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache'}};
      axios({
          method: "POST",
          url: "/api/get-company-settings",
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')}
        })
        .then(response => {
            let data = response.data.data;
            if(data){
              this.company_settings = data.settings
               localStorage.setItem('settings', JSON.stringify(data.settings));
               if(data.settings.backgroung_logo)
                localStorage.setItem('admin_bg', JSON.stringify(url+data.settings.backgroung_logo));
              else
                localStorage.setItem('admin_bg','');
            }


         })
          .catch(err => {
            // Vue.$toast.error(err, {
            // position: 'top-right'
            // });

           });

     },
     checkPermission(flag) {
     
      if(flag == 'sales'){
        let status = 0;
        if(this.company_settings.sales_rep_flag == 'None'){
          return false
        }
        else if(this.company_settings.sales_rep_flag == 'All'){
          return true
        }else{
          if(this.company_settings.sales_rep_accounts.length != 0){
          this.company_settings.sales_rep_accounts.forEach(val => {
            if(val == this.company.user_id){
              status = 1;
            }
            
          });
        }
          return status
        }
      }
      if(flag == 'ref'){
        let status_ref = 0;
        if(this.company_settings.ref_rep_flag == 'None'){
          return false
        }
        else if(this.company_settings.ref_rep_flag == 'All'){
          return true
        }else{
          this.company_settings.ref_rep_accounts.forEach(val => {
            if(val == this.company.user_id){
              status_ref = 1;
            }
            
          });
          return status_ref
        }
      }
     },
     checkPermissionPurchaseProgram(flag) {
        let status = 0;
        if(this.company_settings.display_purchase_program == 'None'){
          return false
        }
        else if(this.company_settings.display_purchase_program == 'All'){
          return true
        }else{
          if(this.company_settings.display_purchase_program_custom.length != 0){
          this.company_settings.display_purchase_program_custom.forEach(val => {
            if(val == this.company.user_id){
              status = 1;
            }
            
          });
        }
          return status
        }
     },
  exportToFile(card, name='contact', force=true) {
            const a = document.createElement('a');
            const file = new Blob([card], { type: 'text/vcard'});

            a.href = URL.createObjectURL(file);
            a.download = name;
            a.click();

            URL.revokeObjectURL(a.href);
  },
  viewInventory(){
    
    this.$router.push('/inventory-filter')
   
  },
  viewInventoryRental(){
    
    this.$router.push('/rental-inventory-filter')
   
  },
  getIcon(id,value){
    if(id == 'Phone'){
      this.phone = value
      return 'fa fa-phone';
    }
    if(id == 'Zoom'){
      this.zoom_value = value
      return 'fas fa-video';
    }
    if(id == 'Event'){
      this.event_value = value
      return 'fas fa-calendar-check';
    }
    if(id == 'Email')
      return 'fas fa-envelope';
    if(id == 'Whatsapp')
      return 'fab fa-whatsapp';
    if(id == 'SMS/Text')
      return 'fas fa-comments';
    if(id == 'Website')
      return 'fas fa-link';
    if(id == 'Instagram')
      return 'fab fa-instagram';
    if(id == 'Snapchat')
      return 'fab fa-snapchat';
    if(id == 'Twitter')
      return 'fab fa-twitter';
    if(id == 'Facebook')
      return 'fab fa-facebook';
    if(id == 'LinkedIN')
      return 'fab fa-linkedin';
    else
      return 'fas fa-link';
  },
      // Function to convert image URL to Base64
  async convertImageToBase64(imageUrl) {
    let self = this;
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const mimeType = blob.type; // Get the MIME type of the image
    // this.avatar_mimeType = mimeType;
    // this.base64Image = blob
    // const reader = new FileReader();
    //     reader.onloadend = () => { self.base64Image = reader.result.split(',')[1]; self.avatar_mimeType = mimeType }; // Get Base64 string without the prefix
    //     reader.onerror = reject;
    //     reader.readAsDataURL(blob);
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve({ base64Image: reader.result.split(',')[1], mimeType }); // Get Base64 string without the prefix
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
},
/**
 * checkForm
 * login the user with valid email/pass
 */
async addCard(value) {
            const myVCard = new VCard()
            myVCard.addName(this.company.first_name+' '+this.company.last_name)
            if(this.company.business_name)
              myVCard.addCompany(this.company.business_name)
            myVCard.addEmail(this.company.email)
            myVCard.addPhoneNumber(this.company.phone_m)     
            
            // Add social media links if available
            if (this.company.facebook) {
                myVCard.addSocial(this.company.facebook, 'Facebook');
            }
            if (this.company.instagram) {
                myVCard.addSocial(this.company.instagram, 'Instagram');
            }
            if (this.company.linkedin) {
                myVCard.addSocial(this.company.linkedin, 'TikTok');
            }
            if (this.company.website) {
                myVCard.addSocial(this.company.website, 'Website');
            }
            if (this.company.youtube) {
                myVCard.addSocial(this.company.youtube, 'YouTube');
            }
            if (this.company.avatar) {
              if (this.avatar_mimeType == 'image/png') {
                myVCard.addPhoto(`${this.base64Image}`, 'PNG');
              }
              else if (this.avatar_mimeType == 'image/jpeg') {
                myVCard.addPhoto(`${this.base64Image}`, 'JPEG');
              }
              else if (this.avatar_mimeType == 'image/gif') {
                myVCard.addPhoto(`${this.base64Image}`, 'GIF');
              }
            }
            const output = myVCard.toString()
            const preElement = document.querySelector('#output')
            const outputNode = document.createTextNode(output)
            this.exportToFile(output,'contact',true)
          
    }
  },

  computed: {
    filteredUsers() {
      const query = this.search_rep.toLowerCase();
      return this.reps_users.filter(user => {
        const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
        return fullName.includes(query);
      });
    }
  },
  watch: {
    pageTitle() {
      this.$meta().refresh();
    },
  },
    
};
</script>
<style>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

/* HomeSyncX Card Styles */
.homesync-card-app {
  background: #2C3E50 !important;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
}

.homesync-main {
  padding: 0 !important;
  background: #2C3E50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
}

/* Header Styles */
.homesync-header {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  z-index: 10;
}

.header-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px);
}

/* Profile Section */
.homesync-profile-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 20px 100px;
}

.profile-container {
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.profile-image-wrapper {
  margin: 0 auto 30px;
  width: 220px;
  height: 220px;
}

.profile-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 6px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.profile-name {
  color: white;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1.2;
  font-family: 'Inter', sans-serif;
  letter-spacing: -0.5px;
}

.profile-title {
  color: rgba(255, 255, 255, 0.9);
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 4px;
  font-family: 'Inter', sans-serif;
}

.profile-location {
  color: rgba(255, 255, 255, 0.8);
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 30px;
  font-family: 'Inter', sans-serif;
}

/* CTA Button */
.cta-button {
  font-size: 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
  padding: 20px 40px !important;
  height: 64px !important;
  margin-bottom: 40px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
  font-family: 'Inter', sans-serif !important;
  background: #3A7D7C !important;
}

/* Contact Icons */
.contact-icons {
  display: flex;
  justify-content: center;
  gap: 50px;
  margin-top: 20px;
}

.contact-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  border-radius: 12px;
  transition: all 0.3s ease;
  text-decoration: none;
}

.contact-icon:hover {
  background: rgba(58, 125, 124, 0.5);
  transform: translateY(-3px);
}

.contact-icon-symbol {
  color: #5FA9A8;
  font-size: 32px;
}

/* Bottom Navigation Buttons */
.bottom-nav-buttons {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 0;
  background: #2C3E50;
  padding: 12px 10px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
  z-index: 100;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.nav-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
  min-width: 70px;
  flex: 1;
  max-width: 100px;
}

.nav-button:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.nav-icon {
  color: #5FA9A8;
  font-size: 24px;
  margin-bottom: 4px;
}

.nav-label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 11px;
  font-weight: 500;
  text-align: center;
  font-family: 'Inter', sans-serif;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

/* Footer Section */
.homesync-footer {
  background: #1A2332;
  padding: 30px 20px;
  padding-bottom: 100px;
  margin-top: auto;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-left {
  text-align: left;
}

.footer-brand {
  color: white;
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 5px 0;
  line-height: 1;
  font-family: 'Inter', sans-serif;
  letter-spacing: -0.5px;
}

.footer-powered {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin: 0;
  font-family: 'Inter', sans-serif;
}

.footer-right {
  display: flex;
  align-items: center;
}

.verified-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.verified-text {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
}

.verified-label {
  color: white;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.1;
  font-family: 'Inter', sans-serif;
  margin: 0;
}

.verified-partner {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  line-height: 1.1;
  font-family: 'Inter', sans-serif;
  margin: 0;
}

.shield-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
}

.verified-icon {
  color: white;
  font-size: 50px;
  position: absolute;
}

.star-icon {
  position: absolute;
  color: white;
  font-size: 18px;
  z-index: 1;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .homesync-header {
    top: 10px;
    padding: 0 15px;
  }

  .homesync-profile-section {
    padding: 60px 15px 80px;
  }

  .profile-image-wrapper {
    width: 180px;
    height: 180px;
    margin-bottom: 20px;
  }

  .profile-name {
    font-size: 28px;
  }

  .profile-title {
    font-size: 18px;
  }

  .profile-location {
    font-size: 16px;
    margin-bottom: 25px;
  }

  .cta-button {
    font-size: 18px !important;
    padding: 16px 32px !important;
    height: 56px !important;
    margin-bottom: 30px !important;
  }

  .contact-icons {
    gap: 30px;
  }

  .contact-icon {
    width: 55px;
    height: 55px;
  }

  .contact-icon-symbol {
    font-size: 35px !important;
  }

  .bottom-nav-buttons {
    padding: 15px 5px 10px;
    gap: 5px;
  }

  .nav-button {
    padding: 10px 8px;
    min-width: 60px;
    max-width: 80px;
  }

  .nav-icon {
    font-size: 20px;
    margin-bottom: 4px;
  }

  .nav-label {
    font-size: 11px;
  }

  .homesync-footer {
    padding: 35px 95px;
  }

  .footer-content {
    flex-direction: row;
    gap: 15px;
    justify-content: space-between;
    align-items: center;
  }

  .footer-left {
    text-align: left;
  }

  .footer-brand {
    font-size: 22px;
    margin-bottom: 2px;
  }

  .footer-powered {
    font-size: 11px;
  }

  .verified-badge {
    justify-content: center;
    gap: 8px;
  }

  .shield-container {
    width: 40px;
    height: 25px;
  }

  .verified-icon {
    font-size: 20px !important;
  }

  .star-icon {
    font-size: 15px !important;
  }

  .verified-label {
    font-size: 13px;
  }

  .verified-partner {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .homesync-header {
    top: 8px;
    padding: 0 10px;
  }

  .header-btn {
    width: 36px !important;
    height: 36px !important;
  }

  .header-btn .v-icon {
    font-size: 20px !important;
  }

  .homesync-profile-section {
    padding: 50px 10px 20px;
  }

  .profile-image-wrapper {
    width: 150px;
    height: 150px;
    margin-bottom: 15px;
  }

  .profile-image {
    border-width: 3px;
  }

  .profile-name {
    font-size: 24px;
  }

  .profile-title {
    font-size: 16px;
  }

  .profile-location {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .cta-button {
    font-size: 16px !important;
    padding: 14px 24px !important;
    height: 50px !important;
    margin-bottom: 25px !important;
  }

  .contact-icons {
    gap: 20px;
  }

  .contact-icon {
    width: 50px;
    height: 50px;
  }

  .contact-icon-symbol {
    font-size: 30px !important;
  }

  .homesync-footer {
    padding: 30px 90px;
  }

  .footer-content {
    flex-direction: row;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
  }

  .footer-left {
    text-align: left;
  }

  .footer-brand {
    font-size: 18px;
    margin-bottom: 2px;
  }

  .footer-powered {
    font-size: 10px;
  }

  .verified-badge {
    gap: 6px;
  }

  .shield-container {
    width: 35px;
    height: 25px;
  }

  .verified-icon {
    font-size: 25px !important;
  }

  .star-icon {
    font-size: 13px !important;
  }

  .verified-label {
    font-size: 11px;
  }

  .verified-partner {
    font-size: 10px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .profile-image-wrapper {
    width: 200px;
    height: 200px;
  }

  .profile-name {
    font-size: 32px;
  }
}
</style>